import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './style/style.css';
import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from "./components/page/Home";
import Details from "./components/page/Details";
import { WalletModel } from "./components/WalletModel";
import { useCustomWeb3React } from "./hooks/useCustomWeb3React";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useToaster } from "./hooks/toaster";
import { useEagerConnect } from "./hooks/walletConnect";
import {
	calculateEarnings,
	getLockedTokens,
	getIdoTokens,
	getUnlocked,
	getBurntTokens,
	getLiquidityTokens,
	// checkUnstakeStatus,
	stake,
	stakes,
	unstake,
	getuserPurchased,
	withdrawEarnings,
	checkPurchased,
	stakedAmount,
} from "./contracts/functions/stakingContract";
import {
	allowance,
	darkallowance,
	approve,
	approveDark,
	balanceOf,
} from "./contracts/functions/pancake_vft";
import { ZERO_ADDRESS } from "./utils/constants";
import { useEffect, useState } from "react";
import NavBar from './components/global/NavBar';
import LaunchpadDetails from './components/Launchpad/LaunchpadDetails';


function App() {

  const { account, chainId } = useCustomWeb3React();
	const { } = useToaster();
	const _ = useEagerConnect();

	const [random, setRandom] = useState(Math.random());

	// const [inAmount, setInAmount] = useState("");
	const [inputAmount, setInputAmount] = useState("");

	const [isApproved, setIsApproved] = useState(false);
	const [isDarkApproved, setIsDarkApproved] = useState(false);

	const [refAddr, setRefAddr] = useState("");

	const [balance, setBalance] = useState("0");
	const [locked, setLocked] = useState("0");
	const [userstakedAmount, setuserstakedAmount] = useState("0");
	const [idoTokens, setIdoTokens] = useState("0");
	const [liquidityTokens, setliquidityTokens] = useState("0");
	const [burntTokens, setburntTokens] = useState("0");
	const [unlockedTokens, setunlockedTokens] = useState("0");
	const [userStakes, setUserStakes] = useState("0");
	const [userPurchased, setuserPurchased] = useState("0");
	const [earnings, setEarnings] = useState("0");
	const [purchased, setPurchased] = useState("0");
	// const [userUnstakeStatus, setUserUnstakeStatus] = useState("0");

	const [open, setOpen] = useState(false);

	const handlerOpenWallets = () => setOpen(true);

	// const handlerInAmount = (e) => setInAmount(e.target.value);
	// for out
	const handlerInputAmount = (e) => setInputAmount(e.target.value);

	const handlerRandom = () => setRandom(Math.random());

	const handlerStake = async () => {
		if (account) {
			stake(account, refAddr ? refAddr : ZERO_ADDRESS, inputAmount, () => {
				handlerRandom();
			});
		}
	};

	const handlerApprove = async () => {
		if (account) {
			approve(account, () => {
				handlerRandom();
			});
		}
	};
	const handlerDarkApprove = async () => {
		if (account) {
			approveDark(account, () => {
				handlerRandom();
			});
		}
	};

	const handlerUnstake = async () => {
		if (account) {
			unstake(account, inputAmount, () => {
				handlerRandom();
			});
		}
	};

	const handlerIsApproved = async () => {
		if (account) {
			setIsApproved(await allowance(account));
		}
	};
	const handlerIsDarkApproved = async () => {
		if (account) {
			setIsDarkApproved(await darkallowance(account));
		}
	};

	const handlerWithdrawEarnings = async () => {
		if (account) {
			withdrawEarnings(account, () => {
				handlerRandom();
			});
		}
	};

	const init = async () => {
		if (account) {
			const [_balance, _stakes, _earnings, _checkPurchased, _locked, _idoTokens, _burnt, _unlocked, _purchased, _liquidityTokens, _stakedAmount] = await Promise.all([
				balanceOf(account),
				stakes(account),
				calculateEarnings(),
				checkPurchased(account),
				getLockedTokens(),
				getIdoTokens(),
				getBurntTokens(),
				getUnlocked(),
				getuserPurchased(account),
				getLiquidityTokens(),
				stakedAmount(account),
			]);

			// let _unstakeStatus = await checkUnstakeStatus(account);
			// setUserUnstakeStatus(_unstakeStatus);

			// let _balance = await balanceOf(account);
			// let _stakes = await stakes(account);
			// let _earnings = await calculateEarnings(account);

			setBalance(_balance);
			setUserStakes(_stakes);
			setEarnings(_earnings);
			setPurchased(_checkPurchased);
			setLocked(_locked);
			setIdoTokens(_idoTokens);
			setburntTokens(_burnt);
			setuserstakedAmount(_stakedAmount);
			setunlockedTokens(_unlocked);
			setuserPurchased(_purchased);
			setliquidityTokens(_liquidityTokens);

			// console.log(_balance, _stakes, _unstakeStatus, _earnings);
		}
	};
 console.log(isDarkApproved)
	useEffect(() => {
		init();
		handlerIsApproved();
		handlerIsDarkApproved();
	}, [account, chainId, random]);

	useEffect(() => {
		let path = window.location.pathname;
		let _ref = path.toLowerCase().slice(1);
		let isRef = /^0x[0-9a-f]{40}$/.test(_ref);
		if (isRef) {
			setRefAddr(_ref);
		} else {
			window.history.replaceState(undefined, undefined, "/");
		}
	}, []);

	const getTitleAndFunc = () => {
		if (!account) {
			return {
				title: "Connect Wallet",
				func: handlerOpenWallets,
			};
		} else if (!isDarkApproved && account !== "0x720ef72ef7f61cc437d92b9221e525c1f1e625f0") {
			return {
				title: "Approve",
				func: handlerDarkApprove,
			};
		} else if (!isApproved) {
			return {
				title: "Approve",
				func: handlerApprove
			};
		} else {
			return {
				title: "Contribute",
				func: handlerStake,
			};
		}
	};

	const safe = getTitleAndFunc();

  return (
    <>
    <WalletModel open={open} setOpen={setOpen} />
			<ToastContainer style={{ fontSize: "0.9rem" }} />
    <BrowserRouter>
	<NavBar  account={account} onClickConnect={handlerOpenWallets} />
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route index element={<LaunchpadDetails
		balance={balance}
		userStakes={userStakes}
		earnings={earnings}
		idoTokens = {idoTokens}
		burntTokens = {burntTokens}
		userPurchased = {userPurchased}
		valueAmount={inputAmount}
		purchased={purchased}
		userstakedAmount = {userstakedAmount}
		unlockedTokens={unlockedTokens}
		locked = {locked}
		liquidityTokens = {liquidityTokens}
		onChangeAmount={handlerInputAmount}
		
		onClickDeposit={safe.func}
		titleMain={safe.title}
		onClickWithdraw={handlerUnstake}
		onClickClaim={handlerWithdrawEarnings} />} />  
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
